import React, { useState, useEffect } from 'react';
import { Modal, Upload, message, Select, Button, Icon, Typography, Row, Col } from 'antd';
import { platformApi } from '../../../../api';
import { ENDPOINT } from '../../../../constants';

const { Text } = Typography;

const getFullUrl = (filePath) => {
  if (!filePath) return '';
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) return filePath;
  const cleanEndpoint = ENDPOINT.endsWith('/') ? ENDPOINT.slice(0, -1) : ENDPOINT;
  const cleanPath = filePath.startsWith('/') ? filePath : `/${filePath}`;
  return `${cleanEndpoint}${cleanPath}`;
};

let urls = process.env.NODE_ENV === "development" ? "http://localhost:4000/" : "/";

export default function CSVPartsUpload(props) {
  const { open, close, upload, setfile } = props;

  const [manufacturer, setManufacturer] = useState([]);
  const [id, setId] = useState(undefined);
  const [templateLink, setTemplateLink] = useState('');

  useEffect(() => {
    if (open) {
      platformApi
        .get("/api/manufacturer/")
        .then(res => {
          const { data } = res;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              setManufacturer(response.data);
            } else {
              message.error("Unable to fetch Manufacturers", 2);
            }
          } else {
            message.error("Unable to fetch Manufacturer", 2);
          }
        });
      platformApi
        .get('/api/partsMaster/template')
        .then(res => {
          let { data } = res;
          if (data.code === 200 && data.response) {
            setTemplateLink(getFullUrl(data.response));
          }
        });
    }
  }, [open]);

  const beforeDocUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 50;
    if (!isLt2M) {
      message.error("Document must smaller than 50MB!");
    }
    return isLt2M;
  };

  const handleTemplateClick = (e) => {
    e.stopPropagation();
    if (!templateLink) {
      e.preventDefault();
      message.warning("Template file is not ready yet. Please try again in a moment.");
      return;
    }
    window.open(getFullUrl(templateLink), "_blank");
  };

  return (
    <div>
      <Modal
        bodyStyle={{ width: '10vw' }}
        title="CSV Upload"
        visible={open}
        onCancel={() => {
          close();
          setId(undefined);
        }}
        okButtonProps={{ style: { display: 'none' } }}
      >
        <Select
          placeholder="Manufacturer"
          style={{ width: '18vw' }}
          onChange={(id) => setId(id)}
          value={id}
          showAction={["click", "focus"]}
        >
          {manufacturer.map((item, index) => (
            <Select.Option key={item.id}>{item.name}</Select.Option>
          ))}
        </Select>
        <br></br>
        <br></br>
        <br></br>
        <div style={{ display: 'flex', width: '100%' }}>
          <Upload
            beforeUpload={e => beforeDocUpload(e)}
            onChange={event => {
              setfile(true);
              upload(event, id);
            }}
            action={`${urls}api/upload/mocky`}
            accept=".xlsx"
            disabled={!id}
          >
            <Button type="primary" disabled={!id}>
              <Icon type="upload" />
              <Text style={{ color: "lightgray" }}>
                Upload CSV Data
              </Text>
            </Button>
          </Upload>
        </div>

        <br></br>
        <div style={{ width: '400%' }}>
          <span style={{ width: '100%', marginBottom: '10px' }}>*(Accepts only .xlsx files)</span><br></br>
          <a href={templateLink ? getFullUrl(templateLink) : '#'} target="_blank" download style={{ minWidth: '16.7rem', marginTop: '5px' }}
            onClick={handleTemplateClick} className="linkylink" rel="noreferrer">
            Download Template Here for Parts Master
          </a>
        </div>

      </Modal>
    </div>
  );
}
